import { supabase } from "@/integrations/supabase/client"

export interface NormalizePlacaResult {
  placa: string | null
  confianca: "alta" | "baixa"
}

export async function normalizarPlaca(transcricao: string): Promise<NormalizePlacaResult> {
  const { data, error } = await supabase.functions.invoke<NormalizePlacaResult>(
    "ai-normalize-placa",
    { body: { transcricao } },
  )

  if (error) {
    throw new Error(error.message || "Falha ao normalizar placa")
  }
  if (!data) {
    throw new Error("Resposta vazia da função de IA")
  }
  return data
}
